import React from 'react';
import { Nav, Card, Navbar, Image, Container } from '@themesberg/react-bootstrap';

import ReactLogo from "../../src/assets/img/technologies/react-logo-transparent.svg";
export default () => {
  return (<>
    <Navbar variant="dark" expand="lg" bg="dark" className="navbar-transparent navbar-theme-primary my-2">
      <Container className="position-relative">
        <Navbar.Brand href="/" className="me-lg-3">
          <Image src={ReactLogo} />
        </Navbar.Brand>

        <Navbar.Collapse id="navbar-default-primary" className="w-100">
          <Nav className="navbar-nav-hover align-items-lg-center">
            <Nav.Link href="/ranking">Ранкинг</Nav.Link>
            <Nav.Link href="/players">Играчи</Nav.Link>
            <Nav.Link href="/matches">Мачове</Nav.Link>
          </Nav>
        </Navbar.Collapse>

        <Navbar.Toggle aria-controls="navbar-default-primary" />
      </Container>
    </Navbar>
  </>);
};